/**
 * Groups an array of objects by a specified property.
 * 
 * @example
 * 
 * const array = [
 *   { id: 1, category: 'A' },
 *   { id: 2, category: 'B' },
 *   { id: 3, category: 'A' },
 * ];
 *
 * groupBy(array, 'category');
 * 
 * // Output:
 * {
 *   A: [{ id: 1, category: 'A' }, { id: 3, category: 'A' }],
 *   B: [{ id: 2, category: 'B' }]
 * }
 * 
 * @param array The array of objects to be grouped.
 * @param property The property name to group by.
 * @returns An object
 */
export const groupBy = <T>(array: T[] | undefined, property: keyof T): Record<string | number, T[]> => {
  return (
    array?.reduce((acc, obj) => {
      const key = obj[property] as unknown as string | number;

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(obj);
      return acc;
    }, {} as Record<string | number, T[]>) ?? {}
  );
};
